export default {
    "Dev": {
        SFDC_SITE_URL_PREFIX: "https://sobeys--uat--c.sandbox.vf.force.com",
        SFSC_AJAX_CONNECTION: "https://sobeys.lightning.force.com/soap/ajax/56.0/connection.js",
        SFSC_AJAX_APEX: "https://sobeys.lightning.force.com/soap/ajax/56.0/apex.js",
        SVC_INIT_ONE: "https://sobeys--uat.sandbox.my.salesforce.com",
        SVC_INIT_TWO: "https://sobeys--uat.sandbox.my.salesforce-sites.com/customerCare",
        ORG_ID: "00D1D00000019GO",
        BANNER: "SCC_Sobeys",
        BASE_LIVE_AGENT_CONTENT_URL: "https://c.la12s-core1.sfdc-58ktaz.salesforceliveagent.com/content",
        DEPLOYMENT_ID: "5721D0000004DLr",
        BUTTON_ID: "5731D0000004KK1",
        BASE_LIVE_AGENT_URL: "https://d.la12s-core1.sfdc-58ktaz.salesforceliveagent.com/chat",
        LIVE_AGENT_DEV_NAME: "EmbeddedServiceLiveAgent_Parent04Ig0000000CanSEAS_179e53b15cd",
        ESW_SCRIPT: "https://sobeys--uat.sandbox.my.salesforce.com/embeddedservice/5.0/esw.min.js",
        ESW_INIT_SCRIPT: "https://service.force.com",
        TRANSCRIPT_USERNAME: "mochanna@deloitte.ca.uat",
        TRANSCRIPT_PASSWORD: "Mohammedwac1937IOuwmiDrOZkd2UNZswRidDmKL",
    },
    "Qa": {
        SFDC_SITE_URL_PREFIX: "https://sobeys--uat--c.sandbox.vf.force.com",
        SFSC_AJAX_CONNECTION: "https://sobeys.lightning.force.com/soap/ajax/56.0/connection.js",
        SFSC_AJAX_APEX: "https://sobeys.lightning.force.com/soap/ajax/56.0/apex.js",
        SVC_INIT_ONE: "https://sobeys--uat.sandbox.my.salesforce.com",
        SVC_INIT_TWO: "https://sobeys--uat.sandbox.my.salesforce-sites.com/customerCare",
        ORG_ID: "00D1D00000019GO",
        BANNER: "SCC_Sobeys",
        BASE_LIVE_AGENT_CONTENT_URL: "https://c.la12s-core1.sfdc-58ktaz.salesforceliveagent.com/content",
        DEPLOYMENT_ID: "5721D0000004DLr",
        BUTTON_ID: "5731D0000004KK1",
        BASE_LIVE_AGENT_URL: "https://d.la12s-core1.sfdc-58ktaz.salesforceliveagent.com/chat",
        LIVE_AGENT_DEV_NAME: "EmbeddedServiceLiveAgent_Parent04Ig0000000CanSEAS_179e53b15cd",
        ESW_SCRIPT: "https://sobeys--uat.sandbox.my.salesforce.com/embeddedservice/5.0/esw.min.js",
        ESW_INIT_SCRIPT: "https://service.force.com",
        TRANSCRIPT_USERNAME: "mochanna@deloitte.ca.uat",
        TRANSCRIPT_PASSWORD: "Mohammedwac1937IOuwmiDrOZkd2UNZswRidDmKL",
    },
    "Stg": {
        SFDC_SITE_URL_PREFIX: "https://sobeys--uat--c.sandbox.vf.force.com",
        SFSC_AJAX_CONNECTION: "https://sobeys.lightning.force.com/soap/ajax/56.0/connection.js",
        SFSC_AJAX_APEX: "https://sobeys.lightning.force.com/soap/ajax/56.0/apex.js",
        SVC_INIT_ONE: "https://sobeys--uat.sandbox.my.salesforce.com",
        SVC_INIT_TWO: "https://sobeys--uat.sandbox.my.salesforce-sites.com/customerCare",
        ORG_ID: "00D1D00000019GO",
        BANNER: "SCC_Sobeys",
        BASE_LIVE_AGENT_CONTENT_URL: "https://c.la12s-core1.sfdc-58ktaz.salesforceliveagent.com/content",
        DEPLOYMENT_ID: "5721D0000004DLr",
        BUTTON_ID: "5731D0000004KK1",
        BASE_LIVE_AGENT_URL: "https://d.la12s-core1.sfdc-58ktaz.salesforceliveagent.com/chat",
        LIVE_AGENT_DEV_NAME: "EmbeddedServiceLiveAgent_Parent04Ig0000000CanSEAS_179e53b15cd",
        ESW_SCRIPT: "https://sobeys--uat.sandbox.my.salesforce.com/embeddedservice/5.0/esw.min.js",
        ESW_INIT_SCRIPT: "https://service.force.com",
        TRANSCRIPT_USERNAME: "mochanna@deloitte.ca.uat",
        TRANSCRIPT_PASSWORD: "Mohammedwac1937IOuwmiDrOZkd2UNZswRidDmKL",
    },
    "Prod": {
        SFDC_SITE_URL_PREFIX: "https://service.force.com/embeddedservice/5.0/esw.min.js",
        SFSC_AJAX_CONNECTION: null,
        SFSC_AJAX_APEX: null,
        SVC_INIT_ONE: "https://sobeys.my.salesforce.com",
        SVC_INIT_TWO: "https://sobeys.my.salesforce-sites.com/customerCare",
        ORG_ID: "00D1U0000012jGb",
        BANNER: "SCC_Sobeys",
        BASE_LIVE_AGENT_CONTENT_URL: "https://c.la1-core1.sfdc-58ktaz.salesforceliveagent.com/content",
        DEPLOYMENT_ID: "5721U0000009jRM",
        BUTTON_ID: "5731U000000R2gs",
        BASE_LIVE_AGENT_URL: "https://d.la1-core1.sfdc-58ktaz.salesforceliveagent.com/chat",
        LIVE_AGENT_DEV_NAME: "EmbeddedServiceLiveAgent_Parent04Ig0000000CanSEAS_179e53b15cd",
        ESW_SCRIPT: "https://sobeys.my.salesforce.com/embeddedservice/5.0/esw.min.js",
        ESW_INIT_SCRIPT: "https://service.force.com",
        TRANSCRIPT_USERNAME: null,
        TRANSCRIPT_PASSWORD: null,
    }
}

